import store from "../../../../../store";
import {updateSQFTCalculations} from "../../../../../actions/sqftFunctions";
const SqftStore = {
  viewGL: null,
  ctxCenter: {
    x: 0,
    y: 0,
  },
  canvas: {
    width: 0,
    height: 0
  },
  radius: {
    arcLength: 0,
    angle: 0,
    clickedEdgeButton: null,
    featureId: null,
  },
  edgeFeatureGroup: null,
  backsplashFeatureGroups: {},
  edgeFeatures: [],
  isSlabMode: () => {
    const reduxState = store.getState();
    return reduxState.sqftSlabState.isShowSlabTool;
  },
  isRegularMode: () => {
    const reduxState = store.getState();
    return !reduxState.sqftSlabState.isShowSlabTool;
  },
  updateCalculations: () => {
    const state = store.getState();
    const updateCalculations = state.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  },
  getShapeType: () => {
    //todo
  },
  seamHistory: [],
  setSeamHistory: function(seamHistory) {
    this.seamHistory = seamHistory
  },
  addSeamHistory: function(shapeId) {
    this.seamHistory.push(shapeId)
  },
  getSeamHistory: function() {
    return this.seamHistory;
  }
};

export default SqftStore
